import type { PhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';

export const getTemplateImageUrl = (filename: string, version: string = '1638397480'): string =>
  `https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/new-websites/${filename}.jpg?v=${version}`;

export const getTemplateDefaultHeaderPhotoUrl = (templateId: string, photoIndex: string = '', version: string = '1638397480'): string =>
  `https://withjoy.com/assets/public/wedding-website/designs-gallery/default-assets/${templateId}${photoIndex}.png?v=${version}`;

export const generateDefaultPhotoData = (id: string, totalPhotoCount: number, width: number, height: number) => {
  return Array.from({ length: totalPhotoCount }, (_, i) => ({
    id: `${id}-${i + 1}`,
    url: getTemplateDefaultHeaderPhotoUrl(id, totalPhotoCount === 1 ? '' : `${i + 1}`),
    height,
    width,
  }));
};

export const deriveDesignTemplateId = (themeId: string, photoPresentationLayout: PhotoPresentationLayout): string => `${themeId}-${photoPresentationLayout}`;

/**
 * Efficiently concatenates multiple arrays into a single array, ignoring falsy inputs.
 * This avoids multiple spread operations and intermediate array allocations.
 *
 * @param arrays - Variable number of array arguments. Falsy values (false, null, undefined) are ignored.
 * @returns A new mutable array containing all elements from the input arrays.
 *
 * @example
 * concatenateArrays([1, 2], [3, 4], false && [5, 6], [7, 8])
 * // Returns [1, 2, 3, 4, 7, 8]
 */
export const concatenateArrays = <T>(...arrays: ReadonlyArray<ReadonlyArray<T> | false | null | undefined>): T[] => {
  const result: T[] = [];
  for (const arr of arrays) {
    if (arr) {
      result.push(...arr);
    }
  }
  return result;
};
